import React from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Admin from "./Admin";
import AdminShell from "./admin/AdminShell";
import Overview from "./admin/Overview";
import Workspace from "./admin/Workspace";
import EngagementPage from "./EngagementPage";
import { T } from "./theme";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminShell />}>
          <Route index element={<Overview />} />
          <Route path="engagements" element={<Admin />} />
          <Route path=":slug" element={<Workspace />} />
        </Route>
        <Route path="/client/:slug" element={<EngagementPage />} />
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

// Thread's door. Clients reach their portal from the link Thread sent them;
// the organisation list is never shown here.
function Landing() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: T.bgInverse, fontFamily: T.fontSans }}>
      <div className="login-card" style={{ background: T.canvas, borderRadius: T.radiusLg, padding: 48, width: 400, textAlign: "center", boxShadow: T.shadowLg }}>
        <div style={{ color: T.canopy, fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 8 }}>Thread</div>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: T.root, marginBottom: 8 }}>Thread Hub</h1>
        <p style={{ color: T.fgSecondary, fontSize: 14, lineHeight: 1.6, marginBottom: 28 }}>Client portals open from the link Thread sent you.</p>
        <button onClick={() => navigate("/admin")}
          style={{ width: "100%", padding: "12px 0", fontSize: 14, fontWeight: 600, color: T.fgOnDark, background: T.root, border: "none", borderRadius: T.radiusMd, cursor: "pointer", fontFamily: T.fontSans }}>
          Admin sign in
        </button>
      </div>
    </div>
  );
}
